import type { ComponentPropertyBindingType } from '@sapappgyver/appgyver-descriptors/lib/dolan/v4';
import isPrivateBindingType from './isPrivateBindingType';

/**
 * Returns whether or not the binding direction type is considered something
 * that can be READ from the OUTSIDE of the component (when not in template editor).
 * @param bindingType binding direction type
 * @returns whether or not the type is considered readable from outside
 */
export default function isBindingTypeReadableFromOutside(
  bindingType: ComponentPropertyBindingType | null | undefined,
): bindingType is 'outbound' | 'two-way' | null | undefined {
  if (bindingType === 'inbound') {
    // Input only
    return false;
  }
  if (isPrivateBindingType(bindingType)) {
    // Not available outside at all
    return false;
  }
  // Otherwise "outbound", "two-way" or nullish, which means "two-way"
  return true;
}
